module.exports = __webpack_public_path__ + "img/1.953e0177.png";